<template>
    <div class="news-detail-page my-container page">
        <div class="wrapper">
            <div class="headings">
                <h2>{{ t('headings') }}</h2>
                <ul class="list">
                    <li v-for="(heading, i) in headings" :key="heading" @click="scrollToHeading(i)">
                        <NuxtLink :to="{ hash: `#news-heading-${i}` }">
                            <Icon name="ph:minus" /> {{ heading }}
                        </NuxtLink>
                    </li>
                </ul>
            </div>

            <div class="content">
                <h1 class="header">{{ newsData.title[locale] }}</h1>
                <img :src="newsData.image" class="banner" :alt="newsData.title[locale]">
                <div class="headings-inner mobile">
                    <h2>{{ t('headings') }}</h2>
                    <ul class="list">
                        <li v-for="(heading, i) in headings" :key="heading" @click="scrollToHeading(i)">
                            <NuxtLink :to="{ hash: `#news-heading-${i}` }">
                                <Icon name="ph:minus" /> {{ heading }}
                            </NuxtLink>
                        </li>
                    </ul>
                </div>
                <template v-for="(entry, i) in newsData.contents" :key="i">
                    <img :src="entry.image" :alt="entry.title[locale]" v-if="entry.image">
                    <h2 class="section-header" ref="headingRef">{{ entry.title[locale] }}</h2>
                    <span v-html="entry.description[locale]"></span>
                </template>
            </div>

        </div>
        <div class="recommendations" v-if="recs.length">
            <h2 class="header">{{ t('youMayLike') }}</h2>
            <div class="list">
                <ApplicationNewsCard v-for="entry in recs" :key="entry.id" :news-data="entry" />
            </div>
        </div>
    </div>
</template>

<script setup>
const { t, locale } = useI18n()
const route = useRoute()
const rc = useRuntimeConfig();

const newsData = ref((await $fetch(rc.public.api + '/api/post/' + route.params.id)).data)
const headings = computed(() => newsData.value.contents.map(el => el.title[locale.value]))
const headingRef = ref()

function scrollToHeading(i) {
    const rect = headingRef.value[i].getBoundingClientRect();
    window.scrollTo({ top: window.scrollY + rect.y - 100 })
}

const recs = ref([])
async function getPosts() {
    const res = await $fetch(rc.public.api + '/api/post', {
        query: {
            page: 1,
            limit: 5,
            'filters[tag_id]': newsData.value.tag.id
        }
    })
    recs.value = res.data.list.filter(el => el.id !== newsData.value.id).slice(0, 4)
}
await getPosts();
</script>